import { render, staticRenderFns } from "./inspectionPointList.vue?vue&type=template&id=cd370044&scoped=true"
import script from "./inspectionPointList.vue?vue&type=script&lang=js"
export * from "./inspectionPointList.vue?vue&type=script&lang=js"
import style0 from "./inspectionPointList.vue?vue&type=style&index=0&id=cd370044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd370044",
  null
  
)

export default component.exports